var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ui-blog-post',{attrs:{"props-data":_vm.uiBlogPostPropsData}},[_c('ce-renderer',{attrs:{"content":_vm.data.contentElements,"frame":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }